// node modules
import { createUseStyles } from 'react-jss'

import { ThemeProps } from 'themes';

export const useStyles = createUseStyles(({ input, typography }: ThemeProps) => ({
    inputWrapper: input.inputWrapper,
    input: input.input,
    inputCloseIconClass: {
        padding: '16px 16px 16px 0',
    },
    inputActiveClass: {
        backgroundImage: 'linear-gradient(#1375D6, #1375D6)',
        backgroundPosition: 'bottom 0 center',
        backgroundSize: '100% 2px',
        backgroundRepeat: 'no-repeat',
    },
    inputDisabledClass: {
        cursor: 'not-allowed',
        opacity: .4
    },
    inputErrorClass: {
        backgroundImage: 'linear-gradient(#FF4D2B, #FF4D2B)',
        backgroundPosition: 'bottom 0 center',
        backgroundSize: '100% 2px',
        backgroundRepeat: 'no-repeat',
    },
    inputLabelClass: {},
    inputLabelActiveClass: typography.inputLabelActive,
    inputLabelErrorClass: typography.inputLabelError,
    inputEndAdornmentClass: {
        marginTop: '20px',
    },
    inputPlaceholderActiveClass: {
        display: 'none'
    },
}));

